export default [
  {
    prop: 'start_day',
    label: '结账周期'
  },
  {
    prop: 'rcon_price',
    label: '对账金额'
  },
  {
    prop: 'info',
    label: '已开票金额'
  },
  {
    prop: 'invoice_time',
    label: '开票日期'
  },
  {
    prop: 'invoice_status',
    label: '状态'
  },
  {
    prop: 'action',
    width: '120px',
    label: '操作'
  }
]
